/* eslint-disable max-len */
/* eslint-disable require-jsdoc */
export default class Header {
  constructor() {
    this.$setting = {
      menuShow: false,
    };

    this.$mainHeader = jQuery('.main-header');
    this.$mainNav = this.$mainHeader.find('.navbar-nav');

    jQuery([document.documentElement, document.body]).animate({
      scrollTop: 0
    }, 0);

    this.events();
  }

  events() {
    let resizeTimeout;
    const mobileBreakpoint = 1024;
    let isMobile = jQuery(window).outerWidth() <= mobileBreakpoint;
    const $navToggler = jQuery('.navbar-toggler');
    const $dom = jQuery('html');

    $navToggler.on('click', (e) => {
      e.preventDefault();

      $navToggler.toggleClass('extended');
      $dom.toggleClass('navigation-extended');

      if ( $navToggler.hasClass('extended') ) {
        jQuery('#stack-menu').addClass('show-menu');
      } else {
        jQuery('#stack-menu').removeClass('show-menu');
        jQuery('#stack-menu').removeClass('mobile-navbar-open').find('.menu-item').removeClass('mobile-item-open mobile-subitem-open');
      }
    });

    if ( !jQuery('#mobile-menu-back').length ) {
      jQuery('#stack-menu').prepend('<button id="mobile-menu-back"></button>');
    }

    jQuery(window).on('resize', function() {
      window.requestAnimationFrame(function() {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(function() {
          if ( jQuery(window).outerWidth() <= mobileBreakpoint ) {
            const homePages = ['/en/home/', '/bg/%d0%bd%d0%b0%d1%87%d0%b0%d0%bb%d0%be/', '/gate/bg/%d0%bd%d0%b0%d1%87%d0%b0%d0%bb%d0%be/', '/gate/en/home/'];
            homePages.includes(window.location.pathname) ? jQuery('.navbar-nav').children().first().addClass('active') : jQuery('.navbar-nav').children().first().removeClass('active');
          }

          function resetMobileMenu() {
            jQuery('html').removeClass('navigation-extended');
            jQuery('#stack-menu').removeClass('mobile-navbar-open').find('.menu-item').removeClass('mobile-subitem-open mobile-item-open');
          }

          if ( jQuery(window).outerWidth() <= mobileBreakpoint && !isMobile ) {
            isMobile = true;
            resetMobileMenu();
          } else if ( jQuery(window).outerWidth() > mobileBreakpoint && isMobile ) {
            isMobile = false;
            resetMobileMenu();
          }
        }, 250);
      });
    });

    this.renderMobileNavigation();
    this.stickyHeader();
    this.langSelector();

    jQuery('body').on('click', '#mobile-menu-back', function(e) {
      e.preventDefault();

      jQuery('#stack-menu').removeClass('mobile-navbar-open').find('.menu-item').removeClass('mobile-item-open mobile-subitem-open');
    });

    this.$mainNav.on('click', 'a', function(e) {
      if ( jQuery(window).outerWidth() <= mobileBreakpoint ) {
        e.preventDefault();
        e.stopPropagation();

        if ( jQuery(e.currentTarget).attr('href') !== '#' ) {
          window.open(jQuery(e.currentTarget).attr('href'), '_self');
        }
      }
    });

    this.$mainNav.on('click', '> .menu-item-has-children', function(e) {
      if ( jQuery(window).outerWidth() <= mobileBreakpoint ) {
        e.preventDefault();

        jQuery('#stack-menu').addClass('mobile-navbar-open').find('.menu-item').removeClass('mobile-item-open');
        jQuery(e.currentTarget).addClass('mobile-item-open');
      }
    });

    this.$mainNav.on('click', '> .menu-item > ul > .stack-menu-list-items > .menu-item-has-children .menu-item', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });

    this.$mainNav.on('click', '> .menu-item > ul > .stack-menu-list-items > .menu-item-has-children', function(e) {
      if ( jQuery(window).outerWidth() <= mobileBreakpoint ) {
        e.preventDefault();

        if ( jQuery(e.currentTarget).hasClass('mobile-subitem-open') ) {
          jQuery('#stack-menu').find('.menu-item').removeClass('mobile-subitem-open');
        } else {
          jQuery('#stack-menu').find('.menu-item').removeClass('mobile-subitem-open');
          jQuery(e.currentTarget).addClass('mobile-subitem-open');
        }
      }
    });
  }

  langSelector() {
    const selector = document.querySelector('#lang-selector');
    
    setTarget();

    window.addEventListener('resize', function() {
      setTarget();
    });

    function setTarget() {
      if ( window.innerWidth <= 1024 ) {
        selector.setAttribute('aria-controls', 'lang-selector-mobile');
        selector.setAttribute('href', '#lang-selector-mobile');
      } else {
        selector.setAttribute('aria-controls', 'lang-selector-desktop');
        selector.setAttribute('href', '#lang-selector-desktop');
      }
    }
  }


  renderMobileNavigation() {
    const homePages = ['/en/home/', '/bg/%d0%bd%d0%b0%d1%87%d0%b0%d0%bb%d0%be/', '/gate/bg/%d0%bd%d0%b0%d1%87%d0%b0%d0%bb%d0%be/', '/gate/en/home/'];
    homePages.includes(window.location.pathname) ? jQuery('.navbar-nav').children().first().addClass('active') : jQuery('.navbar-nav').children().first().removeClass('active');
  }

  stickyHeader() {
    jQuery('body').on('scroll', function() {
      if (jQuery('body').scrollTop() >= 50) {
        jQuery('header.main-header').addClass('fixed-header');
      } else {
        jQuery('header.main-header').removeClass('fixed-header');
      }
    });
  }
}
